import { BlockListActions } from "../actions";

const initialState = {
  clients: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
  client: null,
  cities: {
    rows: [],
    rowCount: 1,
    pageCount: 1,
  },
  city: null,
};

export default function blockList(state = initialState, action) {
  switch (action.type) {
    case BlockListActions.ACTION_SAVE_CLIENTS_BLOCKLIST:
      return {
        ...state,
        clients: action.payload,
      };
    case BlockListActions.ACTION_SAVE_CLIENT_BLOCKLIST:
      return {
        ...state,
        client: action.payload,
      };

    case BlockListActions.ACTION_SAVE_CITIES_BLOCKLIST:
      return {
        ...state,
        cities: action.payload,
      };
    case BlockListActions.ACTION_SAVE_CITY_BLOCKLIST:
      return {
        ...state,
        city: action.payload,
      };
    default:
      return state;
  }
}

export function getClients(state) {
  return state.blockList.clients;
}
export function getClient(state) {
  return state.blockList.client;
}

export function getCities(state) {
  return state.blockList.cities;
}
export function getCity(state) {
  return state.blockList.city;
}
